export enum AuthMethod {
  Email = 'email',
  Phone = 'phone',
}